/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Slim_Trout_HowlInputs */

const en_clear_slim_trout_howl = /** @type {(inputs: Clear_Slim_Trout_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const de_clear_slim_trout_howl = /** @type {(inputs: Clear_Slim_Trout_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefiniert`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {Clear_Slim_Trout_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_slim_trout_howl = /** @type {((inputs?: Clear_Slim_Trout_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Slim_Trout_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_slim_trout_howl(inputs)
	return de_clear_slim_trout_howl(inputs)
});